const mainCourses = [
  {
    id: new Date().getTime().toString(),
    subject: "Python",
    desc:'Expand your career opportunities with Python',
    writeUp:'Take one of Udemy’s range of Python courses and learn how to code using this incredibly useful language. Its simple syntax and readability makes Python perfect for Flask, Django, data science, and machine learning. You’ll learn how to build everything from games to sites to apps. Choose from a range of courses that will appeal to both beginners and advanced developers alike.',
    data: [
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py1.jpg",
        title: "The Complete Python Bootcamp From Zero to Hero in Python",
        author: "Jose Portilla",
        ratings: 4.6,
        numOfStudents:461430,
        cost: 3000,
        prevCost:24000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py2.jpg",
        title: "Automate the Boring Stuff with Python Programming",
        author: "Al Sweigart",
        ratings: 4.6,
        numOfStudents:1085770 ,
        cost: 4600,
        prevCost:18000,
       
      },

      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py3.jpg",
        title: "100 Days of Code: The Complete Python Pro Bootcamp for 2023",
        author: "Dr. Angela Yu",
        ratings: 4.7,
        numOfStudents:2047050 ,
        cost: 5300,
        prevCost:35000,
        bestSeller:true
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py4.jpg",
        title: "Python : Master Programming and Development with 15 Projects",
        author: "Dev Nirwal",
        ratings: 4.1,
        numOfStudents:528795,
        cost: 1200,
        prevCost:15000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py5.jpg",
        title: "Python : Master Programming and Development with 15 Projects",
        author: "Jose Portilla",
        ratings: 4.3,
        numOfStudents:635429 ,
        cost: 1600,
        prevCost:24000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/py6.jpg",
        title: "Python Programming - From Basics to Advanced level [2023]",
        author: "EdYoda Digital University",
        ratings: 4.2,
        numOfStudents:1090547,
        cost: 2300,
        prevCost:14000
      },    
    ],
  },
  {
    id: new Date().getTime().toString(),
    subject: "Excel",
    desc:'Analyze and visualize data with Excel',
    writeUp:'Udemy’s range of Microsoft Excel courses offer training for learners of all levels. Whether you’re a beginner or want to brush up on your skills, we’ve got you covered. And our courses are frequently updated, so you’ll be up to date on the latest features of this powerful software.',
    data: [
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex1.jpg",
        title: "Microsoft Excel - Excel from Beginner to Advanced",
        author: "Kyle Pew",
        ratings: 4.4,
        numOfStudents:1245983,
        cost: 4400,
        prevCost:21000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex2.jpg",
        title: "Zero to Hero in Microsoft Excel: Complete Excel guide 2023",
        author: "Start-Tech Academy",
        ratings: 4.6,
        numOfStudents:416961,
        cost: 5600,
        prevCost:17000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex3.jpg",
        title: "Microsoft Excel Weekender Crash Course",
        author: "Start-Tech Academy",
        ratings: 4.0,
        numOfStudents:303266,
        cost: 1300,
        prevCost:13000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex4.jpg",
        title: "Ms Excel/Excel 2022 - The Complete Introduction to Excel",
        author: "Yassin Marco",
        ratings: 4.2,
        numOfStudents:49318 ,
        cost: 2900,
        prevCost:18000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex5.jpg",
        title: "Beginner to Pro in Excel: Financial Modeling and Valuation",
        author: "365 Careers",
        ratings: 4.7,
        numOfStudents:1358963 ,
        cost: 5100,
        prevCost:12000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/ex6.jpg",
        title: "Microsoft Excel Beginner to Advanced w/ Data Analysis 101",
        author: "Irfan Sharif ACA ACCA",
        ratings: 4.2,
        numOfStudents:267015,
        cost: 3200,
        prevCost:18000
      },


    ],
  },
  {
    id: new Date().getTime().toString(),
    subject: "JavaScript",
    desc:'Grow your software development skills with JavaScript',
    writeUp:'Join more than 12 million learners and train up on JavaScript on Udemy. Choose from a wide range of top-rated JavaScript courses. From back-end development to app or website building, we’ve got you covered. Our real-world experts can lead you through hands-on projects to apply your skills.',
    data: [
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js1.jpg",
        title: "The Complete JavaScript Course: From Zero to Expert!",
        author: "Jonas Schmedtmann",
        ratings: 4.3,
        numOfStudents:1665288 ,
        cost: 3000,
        prevCost:22000
      },

      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js2.jpg",
        title: "Complete JAVASCRIPT with HTML5,CSS3 from zero to Expert-2023",
        author: "Hemanth kumar",
        ratings: 4.6,
        numOfStudents:518248,
        cost: 1400,
        prevCost:19000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js3.jpg",
        title: "Complete Javascript & jQuery Course with Bonus Vue JS Intro",
        author: "Ivan Lourenço Gomes",
        ratings: 4.1,
        numOfStudents:436434,
        cost: 3600,
        prevCost:31000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js4.jpg",
        title: "Learn JavaScript - For Beginners",
        author: "YouAccel Training",
        ratings: 4.7,
        numOfStudents:1592522,
        cost: 2600,
        prevCost:27000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js5.jpg",
        title: "JavaScript And PHP And Python Programming Complete Course",
        author: "PROPER DOT INSTITUTE",
        ratings: 4.3,
        numOfStudents:357491,
        cost: 1700,
        prevCost:15000
      },
      {
        id: new Date().getTime().toString(),
        image:
          "./photos/js6.jpg",
        title: "1 Hour JavaScript",
        author: "John Bura",
        ratings: 4.9,
        numOfStudents:522437,
        cost: 1130,
        prevCost:12000
      },
      
    ],
  },
];

export default mainCourses;
